import { render, staticRenderFns } from "./DyForm.vue?vue&type=template&id=7c8515cc&scoped=true&"
import script from "./DyForm.vue?vue&type=script&lang=js&"
export * from "./DyForm.vue?vue&type=script&lang=js&"
import style0 from "./DyForm.vue?vue&type=style&index=0&id=7c8515cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8515cc",
  null
  
)

export default component.exports